module.exports = __webpack_public_path__ + "assets/img/sad.0cb1328c.svg";